export const initialProjects = [
  {
    id: "rifjala",
    title: "Rifjala",
    category: "Healthcare Platform",
    description: "Official digital presence for a specialized speech-language pathology clinic in Prizren.",
    full_description: "Rifjala.com is the professional platform for the Rifjala clinic, specializing in speech-language pathology (logopedics). The site serves as a clinical resource and service portal for patients seeking therapy for stuttering, autism spectrum disorders, speech delays, and articulation disorders. It features a clean, accessible UI designed to provide information and facilitate clinical appointments for both children and adults.",
    image_url: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=800&q=75&fm=webp",
    tags: ["React", "Healthcare", "Service Platform"],
    tech_stack: ["Tailwind CSS", "Framer Motion", "Vite"],
    challenges: ["Designing for accessibility and readability", "Structuring clinical service information", "Optimizing for local SEO in Prizren"],
    link_url: "https://rifjala.com",
    github_url: "https://github.com/ErgysOnuzi",
    is_visible: true
  },
  {
    id: "real-estate-platform",
    title: "Real Estate Platform",
    category: "Property Management",
    description: "A comprehensive real estate listing and management platform.",
    full_description: "A modern real estate platform designed for property listings, search, and management. Features include advanced filtering, high-quality image galleries, and a responsive interface for seamless property browsing.",
    image_url: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=75&fm=webp",
    tags: ["React", "Next.js", "Real Estate"],
    tech_stack: ["Tailwind CSS", "Supabase", "Framer Motion"],
    challenges: ["Implementing complex search filters", "Optimizing high-resolution property images", "Building a responsive property detail view"],
    link_url: "https://realestate-three-rust.vercel.app",
    github_url: "https://github.com/ErgysOnuzi",
    is_visible: true
  },
  {
    id: "public-document-guide",
    title: "Public Document Guide",
    category: "Information Architecture",
    description: "A specialized guide for navigating administrative processes and public documentation in Kosovo.",
    full_description: "Public Document Guide is a specialized knowledge base designed to simplify the administrative processes of obtaining and managing public documents in Kosovo. The platform provides step-by-step guidance for civil registry documents (birth, marriage, citizenship), identification papers (ID cards, passports), vehicle and property records, and apostille verification. It helps citizens understand office locations, required fees, and necessary supporting documentation through a modern, accessible interface.",
    image_url: "https://images.unsplash.com/photo-1568667256549-094345857637?w=800&q=75&fm=webp",
    tags: ["React", "Documentation", "UX Design"],
    tech_stack: ["Vite", "Tailwind CSS", "Lucide React"],
    challenges: ["Structuring complex information hierarchies", "Optimizing for fast content discovery", "Ensuring cross-device readability"],
    link_url: "https://publicdocumentguidewebsite.vercel.app",
    github_url: "https://github.com/ErgysOnuzi",
    is_visible: true
  },
  {
    id: "syla-service",
    title: "Syla Service",
    category: "Automotive Platform",
    description: "Professional landing page for an automotive diagnostics and repair center in Prizren.",
    full_description: "A modern single-page application built for Syla Service, an automotive diagnostics and repair center located in the Arbana neighborhood of Prizren. The platform provides quick access to technical servicing details, maintenance schedules, and contact information, serving as a high-performance digital gateway for local customers seeking expert vehicle care.",
    image_url: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=75&fm=webp",
    tags: ["React", "Automotive", "Landing Page"],
    tech_stack: ["Vite", "Tailwind CSS", "Vercel"],
    challenges: ["Optimizing for local SEO in Prizren", "Creating a high-performance SPA", "Designing for quick mobile access to contact info"],
    link_url: "https://sylaservice.vercel.app",
    github_url: "https://github.com/ErgysOnuzi",
    is_visible: true
  },
  {
    id: "euroinox",
    title: "Euroinox",
    category: "Business Website",
    description: "Professional corporate presence for a leading industrial manufacturing company.",
    full_description: "A high-end corporate website for Euroinox, focusing on showcasing industrial products and manufacturing capabilities with a modern, clean aesthetic and optimized performance.",
    image_url: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=800&q=75&fm=webp",
    tags: ["React", "Tailwind CSS", "Motion"],
    tech_stack: ["Vite", "Framer Motion", "Lucide React"],
    challenges: ["Creating a premium industrial feel", "Optimizing high-resolution product galleries", "Ensuring seamless mobile navigation"],
    link_url: "https://euroinox.vercel.app/",
    github_url: "https://github.com/ErgysOnuzi",
    is_visible: true
  },
  {
    id: "cleaning-platform",
    title: "Bilingual Cleaning Platform",
    category: "Service Business",
    description: "A comprehensive multilingual platform for booking and managing cleaning services.",
    full_description: "A full-featured service platform that allows users to book cleaning services in multiple languages. Includes a custom pricing engine, automated scheduling, and a client management system.",
    image_url: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=75&fm=webp",
    tags: ["Next.js", "TypeScript", "i18n"],
    tech_stack: ["Tailwind CSS", "Supabase", "Resend"],
    challenges: ["Implementing complex bilingual logic", "Building a dynamic pricing calculator", "Automating booking confirmations"],
    link_url: "https://bilingualcleaningserviceplatform.vercel.app/",
    github_url: "https://github.com/ErgysOnuzi",
    is_visible: true
  },
  {
    id: "ramazani-app",
    title: "Ramazani App",
    category: "Islamic Application",
    description: "A dedicated Islamic application designed for the holy month of Ramadan.",
    full_description: "A comprehensive Islamic application built to assist users during Ramadan. Features include prayer times, fasting schedules, and spiritual resources, all delivered through a clean and intuitive interface optimized for daily use.",
    image_url: "https://images.unsplash.com/photo-1564121211835-e88c852648ab?w=800&q=75&fm=webp",
    tags: ["React", "PWA", "API Integration"],
    tech_stack: ["Vite", "Tailwind CSS", "Lucide React"],
    challenges: ["Accurate time calculations", "Offline functionality", "User-friendly spiritual tracking"],
    link_url: "https://ramazani-one.vercel.app/",
    github_url: "https://github.com/ErgysOnuzi",
    is_visible: true
  },
  {
    id: "zemra-platform",
    title: "Zemra Platform",
    category: "Social & Community",
    description: "A versatile foundation for launching interactive social networks and gamified communities.",
    full_description: "Designed for quickly launching apps where users interact, share, and compete—such as social networks, gamified communities, or group platforms. This project serves as a robust foundation that can be customized for specific community-driven use cases, featuring real-time interactions and engagement tools.",
    image_url: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=75&fm=webp",
    tags: ["Next.js", "Real-time", "Gamification"],
    tech_stack: ["TypeScript", "Supabase", "Tailwind CSS"],
    challenges: ["Scalable interaction logic", "Real-time data synchronization", "Flexible architecture for customization"],
    link_url: "https://zemra-drab.vercel.app/",
    github_url: "https://github.com/ErgysOnuzi",
    is_visible: true
  },
  {
    id: "ergysdev",
    title: "ErgysDev Portfolio",
    category: "Personal Portfolio",
    description: "A high-performance, SEO-optimized portfolio built with React and Tailwind CSS v4.",
    full_description: "This very portfolio you are browsing! Built to showcase my technical skills and professional journey. It features a custom-built blog system, an interactive project gallery, and a secure admin console for managing inquiries. The site is fully optimized for SEO and performance, achieving high scores on PageSpeed Insights.",
    image_url: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=75&fm=webp",
    tags: ["React", "Vite", "Tailwind"],
    tech_stack: ["React", "Vite", "Tailwind", "Supabase", "Vercel", "Figma"],
    challenges: [
      "Implementing a high-performance neon aesthetic using Tailwind CSS v4.",
      "Configuring a dynamic sitemap and SEO system for a Single Page Application.",
      "Building a secure serverless backend for contact form management."
    ],
    link_url: "https://ergys.dev",
    github_url: "https://github.com/ErgysOnuzi",
    is_visible: true
  }
];

export const initialPosts = [
  {
    slug: "mastering-react-hooks",
    title: "Mastering React Hooks: From Basics to Advanced Patterns",
    excerpt: "Deep dive into React Hooks with practical examples and best practices for building modern React applications.",
    date: "Feb 15, 2026",
    readTime: "8 min read",
    category: "Development",
    tags: ["React", "TypeScript", "Architecture"],
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&q=75&fm=webp",
    is_visible: true
  },
  {
    slug: "typescript-tips-2026",
    title: "TypeScript Best Practices for Production Apps",
    excerpt: "Essential TypeScript patterns and techniques that every developer should know in 2026.",
    date: "Feb 10, 2026",
    readTime: "6 min read",
    category: "TypeScript",
    tags: ["TypeScript", "Best Practices", "Development"],
    image: "https://images.unsplash.com/photo-1516116216624-53e697fedbea?w=800&q=75&fm=webp",
    is_visible: true
  }
];